export default "__VITE_ASSET__tbOZ8izZ__"